export const transformToNumber = ({ value, invert }: { value: any; invert?: boolean }) => {
  const number = Number(value)
  return invert && number !== 0 ? -number : number
}

export const replacePeriodToUnderscore = (value: string) => {
  return value.replace(/\./g, '_');
}
